import { render, staticRenderFns } from "./FinancialAffairsUpstreamStatistics.vue?vue&type=template&id=9e04338c&"
import script from "./FinancialAffairsUpstreamStatistics.vue?vue&type=script&lang=js&"
export * from "./FinancialAffairsUpstreamStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports